<div *ngIf="showLoading">
    <div class="p-widget-overlay p-dialog-mask p-loading-mask"></div>
    <div class="percentage-loading-container">
        <span class="percentage">{{percentage}}%</span>
        <p-progressSpinner></p-progressSpinner>
    </div>
</div>